// Strona łącząca w całośc komponenty logowania
import AuthLayout from "./AuthLayout";
import "./login.css";
import "./login-slider.css"

export default function Login() {
    return <AuthLayout />;
}
